export const initialGIOptions = {
  lines: 10,
  bright: 80,
  font: 2,
};
